module.exports = __webpack_public_path__ + "img/add_row_after.e60662a5.svg";